import { SxProps, Theme } from "@mui/material/styles";

const styles: Record<string, SxProps<Theme>> = {
  wrapper: {
    width: "100%",
    minHeight: "500px",
    position: "relative",
  },
  addForm: {
    position: "fixed",
    width: "calc(100% - 250px)",
    bottom: "24px",
  },
  filterWrapper: {
    height: "32px",

    "& button": {
      flexShrink: 0,
    }
  },
  table: {
    maxHeight: "calc(100vh - 296px)",
    display: "flex",
    flexDirection: "column",

    "& .MuiTablePagination-root": {
      flexShrink: 0
    }
  }
};

export default styles;
